import { configureStore } from '@reduxjs/toolkit'
import adminAccessControlReducer from '../../containers/AccessControlList/acl.slice'
import adminPensionCalculationsReducer from '../../containers/PensionCalculation/PensionCalculation.slice'
import adminPensionLogsReducer from '../../containers/PensionLogs/PensionLogs.slice'
import adminPensionReducer from '../../containers/Utm/Pension.slice'
import adminPensionUserReducer from '../../containers/PensionUser/PensionUser.slice'
import adminProjectReducer from '../../containers/Project/Project.slice'
import adminUserProfileReducer from '../../containers/UserProfile/UserProfile.slice'
import authSupabaseReducer from '../../modules/Auth/providers/AuthSupabaseProvider/AuthProvider.slice'
import dashboardReducer from '../../containers/Dashboard/Dashboard.slice'
import notificationsReducer from '../../containers/Notification/Notification.slice'
import onboardingPensionReducer from '../../containers/OnboardingPension/OnboardingPension.slice'
import pensionHistoryReducer from '../../containers/PensionHistory/PensionHistory.slice'
import supportReducer from '../../containers/Support/Support.slice'
import themeReducer from '../../components/Theme/theme.slice'

export const store = configureStore({
  reducer: {
    acl: adminAccessControlReducer,
    adminAuth: authSupabaseReducer, // This state is just to read the user sesion and identity, is not editable
    adminPension: adminPensionReducer,
    adminPensionCalculations: adminPensionCalculationsReducer,
    adminPensionConfig: onboardingPensionReducer,
    adminPensionLogs: adminPensionLogsReducer,
    adminPensionUsers: adminPensionUserReducer,
    adminProject: adminProjectReducer,
    adminUserProfile: adminUserProfileReducer, // This state is to manage the user's information, get basic info and roles
    dashboard: dashboardReducer,
    notifications: notificationsReducer,
    pensionHistory: pensionHistoryReducer,
    support: supportReducer,
    theme: themeReducer,
  },
  devTools: true
})
